
<nav >
  <div style="text-align: right;"><button class="btn-danger" (click)="logout()" >Cerrar sesión</button></div>
</nav>

<div style="margin: 7px;">
  
      <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">

        <li [ngbNavItem]="1">
          <a ngbNavLink>PTW activos</a>
          <ng-template ngbNavContent>
            <app-componente-data4></app-componente-data4>
          </ng-template>
        </li>
        
        <li [ngbNavItem]="2">
          <a ngbNavLink>Estado global de ptws</a>
          <ng-template ngbNavContent>
            <app-componente-data1></app-componente-data1>
          </ng-template>
        </li>

        <li [ngbNavItem]="3">
          <a ngbNavLink>Estado por locación</a>
          <ng-template ngbNavContent>
              <app-componente-data2></app-componente-data2>
          </ng-template>
        </li>

        <li [ngbNavItem]="4">
          <a ngbNavLink>Tareas críticas por unidad de negocio</a>
          <ng-template ngbNavContent>
            <app-componente-data3></app-componente-data3>
          </ng-template>
        </li>

        <li [ngbNavItem]="5">
          <a ngbNavLink>Exportar data por cuenca</a>
          <ng-template ngbNavContent>
            <app-componente-data5></app-componente-data5>
          </ng-template>
        </li>
        
        
      </ul>
      
      <!-- <div [ngbNavOutlet]="nav" class="mt-2"></div> -->
      <div [ngbNavOutlet]="nav"></div>
</div>


